!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, r = {}, a = t.parcelRequire5f74;
  null == a && ((a = function(t) {
    if (t in e) return e[t].exports;
    if (t in r) {
      var a = r[t];
      delete r[t];
      var o = {
        id: t,
        exports: {}
      };
      return e[t] = o, a.call(o.exports, o, o.exports), o.exports;
    }
    var i = new Error("Cannot find module '" + t + "'");
    throw i.code = "MODULE_NOT_FOUND", i;
  }).register = function(t, e) {
    r[t] = e;
  }, t.parcelRequire5f74 = a), (0, a.register)("kmbQD", (function(t, e) {
    var r, a, o, i;
    r = t.exports, a = "default", o = function() {
      return n;
    }, Object.defineProperty(r, a, {
      get: o,
      set: i,
      enumerable: !0,
      configurable: !0
    });
    class n {
      static doChange({id: t, quantity: e, properties: r = {}}, a = !1) {
        return fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: t,
            quantity: e,
            properties: {
              ...r
            }
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart change failed");
          return t.ok && a && this.update(!0), t;
        })).catch((t => t));
      }
      static doUpdate(t, e, r = !1) {
        const a = Array.isArray(t) ? t.reduce(((t, r) => ({
          ...t,
          [r]: e
        })), {}) : {
          id: e
        };
        return fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: a
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart update failed");
          return t.ok && r && this.update(!0), t;
        })).catch((t => t));
      }
      static doAdd({id: t, quantity: e, properties: r = {}}, a = !1) {
        return fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            items: [ {
              id: t,
              quantity: e,
              properties: {
                ...r
              }
            } ]
          })
        }).then((t => {
          if (!t.ok) throw new Error("Cart add failed");
          return t.ok && a && this.update(!0), t;
        })).catch((t => t));
      }
      static getCart() {
        return fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        }).then((t => {
          if (!t.ok) throw new Error("Failed to fetch cart");
          return t;
        })).catch((t => t));
      }
      static update(t = !1, e = "cart-drawer", r = null) {
        try {
          e = e.replace("cart-drawer", document.querySelector("cart-drawer").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
        } catch (t) {}
        (e = e.split(",")).push("header"), e = [ ...new Set(e) ];
        const a = !window.upcart && (!!t || this.cartDrawerOpen);
        fetch(`${location.pathname.replace("/apps/wishlist", "/")}?sections=${e.join(",")}`, {
          method: "GET"
        }).then((t => t.json())).then((t => {
          Object.entries(t).forEach((t => {
            const [e, o] = t, i = (new DOMParser).parseFromString(o, "text/html");
            r ??= [ `[id^="shopify-section-"][id$="${e}"]` ], r.push("header [data-cart-count]", "form [data-cart-count]", "[data-cart-link]"), 
            r.forEach((t => {
              document.querySelectorAll(t).forEach((e => {
                const r = i.querySelector(t);
                r && (e.innerHTML = a ? r.innerHTML.replace('id="Cart"', 'id="Cart" checked') : r.innerHTML);
              }));
            }));
          }));
        }));
      }
    }
  }));
  var o = a("kmbQD");
  class i extends HTMLElement {
    constructor() {
      super(), this.toggle = document.getElementById("Cart");
    }
    connectedCallback() {
      this.addEventListener("click", this.onClickHandler.bind(this)), window.addEventListener("product:added", (() => this.open())), 
      location.hash.includes("Cart") && (history.replaceState("", "", window.location.pathname + window.location.search), 
      this.open());
    }
    open() {
      this.toggle && !window.upcart && (this.toggle.checked = !0, o.default.update(!0));
    }
    close() {
      this.toggle && (this.toggle.checked = !1);
    }
    onClickHandler(t) {
      if (!t.target.hasAttribute("data-ajax")) return;
      t.preventDefault();
      const e = t.target.hasAttribute("data-add"), r = t.target.hasAttribute("data-update"), a = t.target.getAttribute("data-id"), i = parseInt(t.target.getAttribute("data-quantity")), n = {}, d = t.target.getAttribute("data-existing-gift-id");
      Array.from(t.target.attributes).forEach((t => {
        if (t.name.startsWith("data-properties-")) {
          const e = t.name.replace("data-properties-", "");
          n[e] = t.value;
        }
      })), e && d ? o.default.doChange({
        id: d,
        quantity: 0
      }).then((() => {
        o.default.doAdd({
          id: a,
          quantity: i,
          properties: n
        }, !0);
      })) : e ? o.default.doAdd({
        id: a,
        quantity: i,
        properties: n
      }, !0) : r && o.default.doUpdate(a.split(","), i, !0);
    }
  }
  customElements.get("cart-drawer") || customElements.define("cart-drawer", i);
}();